/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'update';
const componentName = 'update-wizard';
const prefix = `${moduleName}.${componentName}`;

export const rollbackBtnLabel = `${prefix}.rollbackBtnLabel`;
export const updateCheckboxLabel = `${prefix}.updateCheckboxLabel`;
export const rollbackCheckboxLabel = `${prefix}.rollbackCheckboxLabel`;
export const clearPatchHeader = `${prefix}.clearPatchHeader`;
export const updateHeader = `${prefix}.updateHeader`;
export const rollbackVersionHeader = `${prefix}.rollbackVersionHeader`;
export const seGroupPatchVersionLabel = `${prefix}.seGroupPatchVersionLabel`;
export const actionTakeLabel = `${prefix}.actionTakeLabel`;
export const recommendCheckMessage = `${prefix}.recommendCheckMessage`;
export const startButtonLabel = `${prefix}.startButtonLabel`;
export const nextButtonLabel = `${prefix}.nextButtonLabel`;
export const optionsQuestionLabel = `${prefix}.optionsQuestionLabel`;
export const preCheckOnlyLabel = `${prefix}.preCheckOnlyLabel`;
export const dryRunLabel = `${prefix}.dryRunLabel`;
export const updateLabel = `${prefix}.updateLabel`;
export const updateDescription = `${prefix}.updateDescription`;
export const dryRunDescription = `${prefix}.dryRunDescription`;
export const preCheckDescription = `${prefix}.preCheckDescription`;
export const rollbackDescription = `${prefix}.rollbackDescription`;
export const letsBeginLabel = `${prefix}.letsBeginLabel`;
export const preCheckLabel = `${prefix}.preCheckLabel`;
export const suppressWarningHeader = `${prefix}.suppressWarningHeader`;
export const additionalRequirementsLabel = `${prefix}.additionalRequirementsLabel`;
export const restoreLabel = `${prefix}.restoreLabel`;
export const uploadBackupFileLabel = `${prefix}.uploadBackupFileLabel`;
export const passphraseLabel = `${prefix}.passphraseLabel`;
export const retriggerPreChecksLabel = `${prefix}.retriggerPreChecksLabel`;
export const selectUpdateLabel = `${prefix}.selectUpdateLabel`;
export const upgradeOperationError = `${prefix}.upgradeOperationError`;
export const upgradePreviewError = `${prefix}.upgradePreviewError`;

export const ENGLISH = {
    [rollbackBtnLabel]: 'Rollback',
    [updateCheckboxLabel]: 'Update All Service Engine Groups',
    [rollbackCheckboxLabel]: 'Rollback All Service Engine Groups',
    [clearPatchHeader]: 'Clear {0} Patch',
    [updateHeader]: '{0} Update',
    [rollbackVersionHeader]: 'Rollback to Version {0}',
    [seGroupPatchVersionLabel]: 'Service Engine Group Patch Version',
    [actionTakeLabel]: 'Action to Take on Service Engine Group Update Failure',
    [recommendCheckMessage]: 'Here are a couple things we recommend you check before upgrading:',
    [startButtonLabel]: 'Start',
    [nextButtonLabel]: 'Next',
    [letsBeginLabel]: 'Let\'s Begin',
    [optionsQuestionLabel]: 'How would you like to proceed?',
    [preCheckOnlyLabel]: 'Pre-check Only',
    [dryRunLabel]: 'Dry Run',
    [updateLabel]: 'Update',
    [preCheckLabel]: 'Pre-check',
    [suppressWarningHeader]: 'Suppress Warnings',
    [updateDescription]: 'Update Avi Load Balancer Controller nodes and Avi Service Engine (SE) nodes to the newer software version; Avi Load Balancer nodes will move to the newer version',
    [dryRunDescription]: 'Dry Run Update of Avi Load Balancer with the newer software version; Avi Load Balancer nodes will stay in the current version',
    [preCheckDescription]: 'Pre Checks that take place prior to Update operations. The Update process will NOT start, and Avi Load Balancer nodes will stay in the current version.',
    [rollbackDescription]: 'Rollback Avi Load Balancer Controller nodes and Avi Service Engine (SE) nodes to the selected software version; Avi Load Balancer nodes will move to the selected version',
    [additionalRequirementsLabel]: 'Additional Requirements',
    [restoreLabel]: 'Restore',
    [uploadBackupFileLabel]: 'Upload Backup File',
    [passphraseLabel]: 'Passphrase',
    [retriggerPreChecksLabel]: 'Retrigger Pre-checks',
    [selectUpdateLabel]: 'Select Update',
    [upgradeOperationError]: 'An error occurred during the upgrade operation',
    [upgradePreviewError]: 'An error occurred while fetching upgrade preview',
};
